import { useQuery } from '@tanstack/react-query';
import { useLocaleForSanity } from 'shared/hooks/useLocale';
import { getQueryKeyForStudio } from 'state/utils/getQueryKeyForStudio';
import { PromotionalBanner } from 'processes/SubscriptionPageV2/hooks/subscriptions.types';
import { sanityFetch } from 'sanity-client';

export function useQueryGetPromotionalBannerData() {
  const locale = useLocaleForSanity();
  const id = `banners-${locale}`;
  const query = `*[_type == "banners" && _id == "${id}"].promotionalBanners`;

  return useQuery({
    queryKey: getQueryKeyForStudio({ keys: ['promotionalBanners', locale] }),
    queryFn: async () => {
      try {
        const promotionalBanner = await sanityFetch<PromotionalBanner[][]>(query, {
          locale
        });

        return promotionalBanner[0] ?? null;
      } catch (error) {
        return null;
      }
    },
    staleTime: Infinity
  });
}
